import Constants from 'expo-constants'
import { Image } from 'expo-image'
import { Button, Text } from 'native-base'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Linking, StyleSheet, View } from 'react-native'

import { UpdateAppImage } from '../../components/images/UpdateApp'
import { Screen } from '../../components/ScreenWrapper/Screen'
import { isiOS } from '../../util/platform'

type Props = {
  partnerLogo: string
  partnerName: string
  /** For example, "itms-apps://itunes.apple.com/app/id1074412639" */
  appStoreItmsAppsUrl?: string
}

export function ForceUpdateAppScreen({ partnerLogo, partnerName, appStoreItmsAppsUrl }: Props) {
  const { t } = useTranslation()

  return (
    <Screen hasPaddingTop={false}>
      <View style={styles.container}>
        <Image
          source={partnerLogo}
          style={styles.image}
          contentFit="contain"
          accessibilityLabel={partnerName}
          accessibilityIgnoresInvertColors
        />
        <UpdateAppImage size={160} />
        <Text fontSize="xl" textAlign="center" bold mt={8}>
          {t('screens.forceUpdateApp.title')}
        </Text>
        <Text fontSize="md" textAlign="center" color="gray.700" mt={1}>
          {t('screens.forceUpdateApp.description')}
        </Text>
        <View style={styles.expand} />
        <Button
          alignSelf="stretch"
          onPress={async () => {
            if (isiOS()) {
              if (appStoreItmsAppsUrl && (await Linking.canOpenURL(appStoreItmsAppsUrl))) {
                await Linking.openURL(appStoreItmsAppsUrl)
                return
              }
              const url = Constants.manifest?.ios?.appStoreUrl
              if (url && (await Linking.canOpenURL(url))) {
                await Linking.openURL(url)
                return
              }
              Linking.openURL('https://www.apple.com/app-store')
            }
          }}
          mb={4}
        >
          {t('screens.forceUpdateApp.updateButton')}
        </Button>
      </View>
    </Screen>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  image: {
    width: 48,
    height: 48,
    marginTop: 16,
    marginBottom: 40,
  },
  expand: {
    flex: 1,
  },
})
